import React from "react";

class PublicLayout extends React.Component<{ children?: React.ReactNode }, any> {
    render(): React.ReactNode {
        const { children } = this.props;
        return (
            <>
                {children}
            </>
        );
    }
}

export default PublicLayout;
